import { THeroTheme, TImage, TIndexableBlock, TLink } from "../../../types";
import { Heading, PrimaryButtonLink, SecondaryButtonLink } from "../../elements";
import HeroCTAShape from "./components/hero-cta-shape/hero-cta-shape";
import styles from "./hero-cta-block.module.less";

type THeroCTABlockProps = {
  theme?: Omit<THeroTheme, "dark-blue" | "beige">;
  eyebrow?: string;
  title: string;
  text?: string;
  buttonLink: TLink;
  imageDesktop: TImage;
  imageMobile: TImage;
} & TIndexableBlock;

export const HeroCTABlock = ({
  theme,
  eyebrow,
  title,
  text,
  buttonLink,
  imageDesktop,
  imageMobile,
  index,
}: THeroCTABlockProps) => {
  const isNotFirstBlock = typeof index === "number" && index > 0;

  return (
    <section className={"max-width padded-sides centered space-mb-2xl"}>
      <div className={`${styles.innerWrapper} theme-${theme}`}>
        <div className={styles.eyebrowTitleWrapper}>
          {eyebrow && <p className={"eyebrow"}>{eyebrow}</p>}
          <Heading className={styles.title} visualType={"h1"} semanticType={isNotFirstBlock ? "h2" : "h1"}>
            {title}
          </Heading>
        </div>
        <div className={styles.textAndButtonWrapper}>
          {text && <p className={"my-0 body-l"}>{text}</p>}
          {theme === "green" && (
            <PrimaryButtonLink
              className={"mt-md"}
              url={buttonLink?.url}
              label={buttonLink?.title}
              onPreNavigate={buttonLink?.onPreNavigate}
            ></PrimaryButtonLink>
          )}
          {theme === "orange" && (
            <SecondaryButtonLink
              className={"mt-md"}
              url={buttonLink?.url}
              label={buttonLink?.title}
              onPreNavigate={buttonLink?.onPreNavigate}
            ></SecondaryButtonLink>
          )}
        </div>
        <div className={styles.shapeWrapper}>
          <HeroCTAShape imageDesktop={imageDesktop} imageMobile={imageMobile} />
        </div>
      </div>
    </section>
  );
};

export default HeroCTABlock;
